import { Avatar, Button, CircularProgress, Divider, Grid } from '@material-ui/core';
import React from 'react';
import CustomAppBar from '../../commons/AppBar';
import SpecificComponent from '../../commons/SpecificComponent';
import LocalStorage from '../../providers/LocalStorage';
import Masks from '../../providers/Masks';
import Utils from '../../providers/Utils';
import Ws from '../../providers/Ws';
import WsC from '../chestionare/providers/WsC';

import avatar from '../../Pics/avatar.jpg'
import FileIcon from '../../providers/FileIcon';
import AlertNew from '../../commons/dialogs/AlertNew';
import generic from '../../Pics/iconsMonitorizare/generic.png'

import DatePicker, { registerLocale, setDefaultLocale, usePopper, popperPlacement } from 'react-datepicker';

import "react-datepicker/dist/react-datepicker.css";

import ro from 'date-fns/locale/ro';
import es from 'date-fns/locale/es'


import { ReactComponent as ThumbUp } from './MonitorizareIcons/thumb_up_black.svg';
import { ReactComponent as ThumbDown } from './MonitorizareIcons/thumb_down_black.svg';
import { ReactComponent as SportSoccer } from './MonitorizareIcons/sports_soccer_black.svg';
import { ReactComponent as HistoryToggle } from './MonitorizareIcons/history_toggle_off_black.svg';

export default class RaportareLunara extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            dataStart: new Date(new Date().setDate(new Date().getDate() - 1)),
            dataEnd: new Date(),
            angajati: [],
            loading: true,
            alertView: false,
            beneficiar: {},
            dateTotale: {},
            aplicatiiAll: { pauza_total: 0, aplicatii_folosite_principale: [], etichete: [] }


        }
    }

    componentDidMount() {
        this.access()
        this.getData()
    }


    m = new Masks()
    u = new Utils()
    ws = new Ws()
    wsC = new WsC()
    ls = new LocalStorage().GetUserData()

    access = async () => {



        console.log('this.ls.InfoUser.IsAdmin :>> ', this.ls.InfoUser.IsAdmin);

        if (this.ls.InfoUser.IsAdmin !== 1) {


            this.setState({ alertView: this.ls.InfoUser.EsteSef === 1 ? false : true })
        }


    }


    getData = async () => {

        // let getData = await this.ws.getData('Monitorizare/UpdateAppsList')


        let _getSocietate = this.ws.customSelect('select * from setari', {
            p1: 'soc_code'
        })

        // if (getData.Succes) {

        let _angajati = this.ws.customSelect(`select a.*, ad.id_departament from angajati a left join angajati_departamente ad
            on a.id = ad.id_angajat where a.data_angajarii <= '${this.u.transformDataForSql(this.state.dataEnd)}' and isnull(a.data_plecarii , '2999-01-01') > '${this.u.transformDataForSql(this.state.dataStart)}' and isnull(a.inactiv,0) != 1 `, {
            p1: this.u.transformDataForSql(this.state.dataEnd),
            p2: this.u.transformDataForSql(this.state.dataStart)
        })

        let _pontaje = this.ws.customSelect(`select * from pontaje where la_data = @p1 and isnull(sters,0) != 1`, {
            p1: this.u.transformDataForSql(this.state.dataStart)
        })



        let _monitorAngajati = this.ws.customSelect(`select ml.*, m.icon from monitorizare_log_folosire ml left join monitorizare_aplicatii m on ml.app_id = m.hash_id
        where Cast(ml.start_datetime as date) >= @p1 and Cast(ml.start_datetime as date) <= @p2  and isnull(m.sters,0) != 1`, {
            p1: this.state.dataStart,
            p2: this.state.dataEnd,
        })



        let _aplicatiiAll = this.ws.customSelect(`select * from monitorizare_aplicatii where isnull(sters,0) != 1`, {
            p1: 1
        })

        let _program = this.ws.customSelect(`select * from program_lucru`, {
            p1: this.props.match.params.idAngajat
        })


        let [angajati, pontaje, monitorAngajati, aplicatiiAll, getSocietate, program] = await Promise.all([_angajati, _pontaje, _monitorAngajati, _aplicatiiAll, _getSocietate, _program])


        if (angajati.Succes && pontaje.Succes && monitorAngajati.Succes  && aplicatiiAll.Succes && getSocietate.Succes && program.Succes) {

            let angajatiIds = new Set(angajati.Content.map(a => a.id_user))
            angajatiIds = [...angajatiIds]

            let evalu = await this.wsC.customSelect(`select top 500 e.*, a.poza, a.id as id_angajat, a.functie, a.nume as nume_user, (select count(*) from raspunsuri_head where id_evaluare = e.id and statusul = @p1) as completari_finalizate, 
            (select count(*) from raspunsuri_head where id_evaluare = e.id ) as completari_toate, s.nume
    from evaluari e left join [${this.ls.InfoUser.Database}].[dbo].[angajati] a on a.id_user = e.id_user_aprobare
    left join sesiuni s on s.id = e.id_sesiune
    where e.id_user_aprobare in (${angajatiIds}) and
    
    isnull(e.inactiv,0) != 1 order by e.id desc ` , {
                p1: 'Finalizat'
            })

            if(evalu.Succes){

                let evaluIds = new Set(evalu.Content.map(evalue => evalue.id))
                evaluIds = [...evaluIds]

            let optiuniRaspuns = await this.wsC.customSelect(`select r.*, h.id_evaluare, h.statusul from raspunsuri_intrebari_raspunsuri r left join raspunsuri_head h on r.id_head = h.id 
            where r.id_head in (select id from raspunsuri_head where id_evaluare in (${evaluIds}))
            order by r.id_optiune_raspuns asc`, {
                    p1: this.props.match.params.idsesiune,
    
                })
    
              
    
                if  (optiuniRaspuns.Succes) {
    
                    let getBeneficiar = await this.ws.customSelect(`select * from [pm_logator].[dbo].societati where id = @p1`, {
                        p1: getSocietate.Content.length > 0 ? getSocietate.Content[0].val : 0
                    })
    
                    let beneficiar = {}
    
                    if (getBeneficiar.Succes) {
    
                        beneficiar = getBeneficiar.Content.length > 0 ? getBeneficiar.Content[0] : {}
                    }
    
    
                    console.log('getSocietate :>> ', getSocietate);
    
                    let ang = [...angajati.Content]
                    let pont = [...pontaje.Content]
                    let optiuniR = [...optiuniRaspuns.Content]
                    let monitor = [...monitorAngajati.Content]
                    let appAll = [...aplicatiiAll.Content]
                    let prg = [...program.Content]
    
    
                    let evaluari = [...evalu.Content]
    
    
                    console.log('optiuniRaspuns :>> ', optiuniRaspuns);
    
    
                    let punctajMaxim = 0
    
                    punctajMaxim = optiuniR.reduce((a, r) => { return a + (r.puncte || 0) }, 0)
    
                    punctajMaxim = punctajMaxim / evaluari.length
    
    
                    for (let j = 0, m = evaluari.length; j < m; j++) {
                        let pct = 0
    
    
                        let filterR = optiuniR.filter(o => o.id_evaluare === evaluari[j].id)
    
                        if (filterR.length > 0) {
                            for (let k = 0, l = filterR.length; k < l; k++) {
    
    
                                pct += filterR[k].raspuns ? filterR[k].puncte : 0 || 0
                            }
    
                            evaluari[j].puncte = pct
                        } else {
                            evaluari[j].puncte = pct
                        }
    
                        evaluari[j].procent_completare = Math.floor(((evaluari[j].completari_finalizate * 100) / evaluari[j].completari_toate) || 0)
    
                        evaluari[j].color = evaluari[j].procent_completare >= 80 ? 'rgb(24 165 58)' : (evaluari[j].procent_completare < 80 && evaluari[j].procent_completare >= 50 ? 'rgb(227 154 10)' : 'rgb(252,93,98)')
                        evaluari[j].color_puncte = evaluari[j].puncte >= (punctajMaxim - (punctajMaxim / 3)) ? 'rgb(24 165 58)' : (evaluari[j].puncte < (punctajMaxim - (punctajMaxim / 3)) && evaluari[j].puncte >= (punctajMaxim / 2) ? 'rgb(227 154 10)' : 'rgb(252,93,98)')
                        evaluari[j].checked = false
                        evaluari[j].raspunsuri = filterR
    
    
    
                    }
    
    
                    for (let i = 0, n = ang.length; i < n; i++) {
    
    
    
                        let filterPontaje = pont.filter(pp => Number(pp.id_angajat) === Number(ang[i].id))
    
                        ang[i]['zile_lucrate'] = 0
    
                        ang[i]['program'] = {}
    
                        ang[i]['pauza_total'] = { pauza_start: '13:00', time: 0 }
    
                        let idxProgram = prg.findIndex(pr => pr.id_angajat === ang[i].id)
    
                        console.log('idxProgram :>> ', idxProgram);
    
                        if (idxProgram !== -1) {
    
                            ang[i]['program'] = prg[idxProgram]
    
                            let intervalZile = this.m.jsDatesDifferenceInDays(this.state.dataStart, this.state.dataEnd)
    
                            console.log('intervalZILE :>> ', intervalZile);
    
                            let pauza = this.u.returnPauzaInterval([ang[i]['program']], this.state.dataStart, intervalZile)
    
                            console.log('pauzaINTERVAL :>> ', pauza);
    
                            // ang[i]['pauza_total'] = pauza
                        }
    
    
                        let idxPontaje = pont.findIndex(pp => Number(pp.id_angajat) === Number(ang[i].id) && this.m.datesAreEgual(new Date(pp.la_data), new Date(this.state.dataAzi)))
    
                        if (idxPontaje !== -1) {
    
                            ang[i]['ora_pornire'] = pont[idxPontaje]['cand_inceput_ora'] || '08:00'
    
    
                        } else {
                            ang[i]['ora_pornire'] = '08:00'
                        }
    
    
                        for (let j = 0, n = filterPontaje.length; j < n; j++) {
    
                            if (filterPontaje[j]['prezent_azi'] === 1) {
    
                                ang[i]['zile_lucrate'] += 1
                                ang[i]['pauza_total'] = { pauza_start: '13:00', time: 30 }
    
                                console.log('ang[i]pontat azi :>> ', ang[i]);
                            }
    
                        }
    
    
    
    
                        let filterEvaluari = evaluari.filter(ee => Number(ee.id_angajat) === Number(ang[i].id))
    
                        if (filterEvaluari.length > 0) {
    
                            console.log('filterEvaluari :>> ', filterEvaluari);
                            ang[i].puncte = filterEvaluari.reduce((a, c) => {
                                console.log('a :>> ', a);
                                console.log('c.puncte :>> ', c.puncte);
                                return a + c.puncte
                            }, 0)
                        } else {
                            ang[i].puncte = 0
    
                        }
    
    
                    }
    
                    console.log('monitor :>> ', monitor);
    
                    let m = JSON.parse(JSON.stringify(monitor))
                    let apAll = JSON.parse(JSON.stringify(appAll))
    
                    let aplicatiiAllFilter = this.u.filterMonitorizareAll(appAll, monitor)
    
                    ang = this.u.filterMonitorizareAngajati(ang, apAll, m)
    
    
    
                    console.log('ang :>> ', ang);
                    // console.log('aplicatiiAllFilter :>> ', aplicatiiAllFilter);
    
                    let pauzaTotalAll = ang.reduce((a, c) => {
                        return a + c.pauza_total.time
                    }, 0)
    
                    aplicatiiAllFilter['pauza_total'] = pauzaTotalAll
    
                    console.log('ang :>> ', ang);
                    console.log('beneficiar :>> ', beneficiar);
    
                    this.setState({
                        angajati: ang,
                        loading: false,
                        beneficiar: beneficiar,
                        aplicatiiAll: aplicatiiAllFilter
                    })
                }

            }





        }


        // }

    }



    numeLuna = (l) => {

        // console.log('l :', l);
        let rez = ''

        switch (l) {
            case 1: rez = this.dictionary.luni.ianuarie; break;
            case 2: rez = this.dictionary.luni.februarie; break;
            case 3: rez = this.dictionary.luni.martie; break;
            case 4: rez = this.dictionary.luni.aprilie; break;
            case 5: rez = this.dictionary.luni.mai; break;
            case 6: rez = this.dictionary.luni.iunie; break;
            case 7: rez = this.dictionary.luni.iulie; break;
            case 8: rez = this.dictionary.luni.august; break;
            case 9: rez = this.dictionary.luni.septembrie; break;
            case 10: rez = this.dictionary.luni.octombrie; break;
            case 11: rez = this.dictionary.luni.noiembrie; break;
            case 12: rez = this.dictionary.luni.decembrie; break;

        }

        return rez
    }

    minusLuna = () => {

        let dataStart = this.state.dataStart

        let dataEnd = this.state.dataEnd


        dataStart = new Date(this.state.dataStart).setMonth(new Date(this.state.dataStart).getMonth() - 1)
        dataEnd = new Date(this.state.dataEnd).setMonth(new Date(this.state.dataEnd).getMonth() - 1)

        dataStart = new Date(dataStart)
        dataEnd = new Date(dataEnd)

        console.log('dataStart :>> ', dataStart);
        console.log('dataEnd :>> ', dataEnd);

        this.setState({
            dataStart: this.m.fistDayMonth(dataStart),
            dataEnd: this.m.lastDayMonth(dataStart),
            loading: true
        }, () => {
            this.getData()
        })
    }


    plusLuna = () => {
        let dataStart = this.state.dataStart

        let dataEnd = this.state.dataEnd


        dataStart = new Date(this.state.dataStart).setMonth(new Date(this.state.dataStart).getMonth() + 1)
        dataEnd = new Date(this.state.dataEnd).setMonth(new Date(this.state.dataEnd).getMonth() + 1)

        dataStart = new Date(dataStart)
        dataEnd = new Date(dataEnd)

        this.setState({
            dataStart: this.m.fistDayMonth(dataStart),
            dataEnd: this.m.lastDayMonth(dataStart),
            loading: true
        }, () => {
            this.getData()
        })
    }



    numeAvatar = (nume) => {

        if (nume) {
            let n = nume.split(' ')

            // console.log('n :>> ', n);

            let firstLetters = ''

            if (n[0]) {

                firstLetters += n[0].substring(0, 1)

            }
            if (n[1]) {
                firstLetters += n[1].substring(0, 1)
            }

            firstLetters = firstLetters.toUpperCase()

            return firstLetters
        } else {
            return 'NA'
        }


    }


    printRaport = (divName) => {
        var printContents = document.getElementById(divName).innerHTML;
        var originalContents = document.body.innerHTML;

        document.body.innerHTML = printContents;

        window.print();

        document.body.innerHTML = originalContents;
    }

    changeData = (ev) => {



        console.log('ev DATA:>> ', ev);
        let dataStart = ev[0]
        let dataFinish = ev[1]



        if (dataFinish) {
            this.setState({
                dataStart: dataStart,
                dataEnd: dataFinish,
                loading: true
            }, () => {
                this.getData()
            })
        } else {
            this.setState({
                dataStart: dataStart,
                dataEnd: dataFinish,

            })
        }
    }


    render() {
        return (
            <div>
                <CustomAppBar history={this.props.history} title={' '} />

                <AlertNew
                    open={this.state.alertView}
                    dialogClose={() => { this.setState({ alertView: false }) }}
                    title={this.dictionary.proiecte.alertView}
                    mesaj={this.dictionary.proiecte.alertViewMessage}
                    noButtonDisplay={1}
                    yesFunction={() => { this.props.history.replace('/') }}
                    fullScreen={true}

                />

                {this.state.loading &&
                    <div className='loading-div' >

                        <CircularProgress
                            style={{
                                width: 60,
                                height: 60,
                                color: '#25e048',
                                marginTop: '40%'
                            }}
                            value={20}

                        />
                        <span style={{ display: 'block', fontSize: 20 }}>Loading...</span>
                    </div>
                }
                <Grid style={{ maxWidth: 1340, margin: 'auto', marginBottom: 40 }} container >
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <h1 style={{ margin: '80px 0 40px 0' }} className='pm-title-big'>{this.dictionary.monitorizare.raportareMonitorizareAngajati} </h1>
                    </Grid>







                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Grid id={'section-to-print'} container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40, overflow: 'scroll' }}>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <Grid container style={{ border: '1px solid #bbbbbb', marginBottom: 20, padding: 10, width: '100%', boxShadow: '0px 3px 10px 0px rgba(119,119,119,0.16)', borderRadius: 5 }}>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Grid container>
                                            <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>
                                                <h5 className='evaluare-noua-subtitlu' style={{ marginTop: 10, fontSize: 24 }} >
                                                    {this.state.beneficiar.nume}
                                                </h5>
                                            </Grid>

                                            <Grid style={{ textAlign: 'right' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                <DatePicker

                                                    selected={this.state.dataStart}
                                                    onChange={this.changeData}
                                                    startDate={this.state.dataStart}
                                                    endDate={this.state.dataEnd}
                                                    selectsRange
                                                    shouldCloseOnSelect={false}
                                                    calendarClassName="calendar-left-absolute"
                                                    locale="ro"
                                                    disabled={this.props.readOnly}
                                                    dateFormat="dd/MM/yyyy"
                                                    customInput={<div className='pm-date-picker'
                                                        style={{
                                                            marginTop: 8,
                                                            border: '1px solid #bdb9b9'
                                                        }}
                                                    >

                                                        <span>


                                                            {this.u.transformDataPoints(this.state.dataStart)} - {this.u.transformDataPoints(this.state.dataEnd)}

                                                            {/* <i onClick={this.props.showCalendarStart} className='material-icons task-edit'>create</i> */}
                                                        </span>
                                                        <i style={{

                                                            fontSize: 18,
                                                            verticalAlign: 'bottom',
                                                            marginLeft: 5

                                                        }} className='material-icons'>today</i>

                                                    </div>}
                                                    monthsShown={2}
                                                    popperPlacement="bottom-left"
                                                />
                                            </Grid>
                                        </Grid>

                                    </Grid>

                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Grid container>
                                            <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                <Grid container>
                                                    <Grid style={{ textAlign: 'left', padding: 10, }} item xs={12} sm={12} md={12} lg={12} xl={12} >

                                                        <h5 className='evaluare-noua-subtitlu pm-monitorizare-bold-text' style={{ marginTop: 0 }} >

                                                            <span>{this.dictionary.monitorizare.distributiaTimpului}</span>
                                                        </h5>
                                                    </Grid>
                                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                        <Grid style={{ paddingTop: 10 }} container>
                                                            <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>

                                                                <div style={{ fontWeight: 600 }}>

                                                                    <div
                                                                        style={{ display: 'inline-block', marginRight: 10, marginLeft: 10, verticalAlign: 'middle' }}
                                                                    >
                                                                        <span style={{ fontWeight: 500, fontSize: 12 }}>
                                                                            <ThumbUp style={{ width: 18, height: 18, }} />
                                                                        </span>

                                                                    </div>

                                                                    <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}> {this.dictionary.monitorizare.timpProductiv} </span><br />

                                                                </div>
                                                            </Grid>

                                                            <Grid style={{ textAlign: 'left' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}>    {this.u.secondsToHoursAndMinutes(this.state.aplicatiiAll.timp_productiv)} </span>
                                                            </Grid>
                                                            <Divider style={{ marginTop: 10, backgroundColor: '#F2F2F2' }} className="pm-divider" />
                                                        </Grid>

                                                        <Grid style={{ paddingTop: 10 }} container>
                                                            <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>

                                                                <div style={{ fontWeight: 600 }}>

                                                                    <div
                                                                        style={{ display: 'inline-block', marginRight: 10, marginLeft: 10, verticalAlign: 'middle' }}
                                                                    >
                                                                        <span style={{ fontWeight: 500, fontSize: 12 }}>
                                                                            <ThumbDown style={{ width: 18, height: 18, }} />
                                                                        </span>

                                                                    </div>

                                                                    <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500, }}> {this.dictionary.monitorizare.timpNeproductiv} </span><br />

                                                                </div>
                                                            </Grid>

                                                            <Grid style={{ textAlign: 'left' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}>   {this.u.secondsToHoursAndMinutes(this.state.aplicatiiAll.timp_neproductiv)}</span>
                                                            </Grid>

                                                            <Divider style={{ marginTop: 10, backgroundColor: '#F2F2F2' }} className="pm-divider" />
                                                        </Grid>

                                                        <Grid style={{ paddingTop: 10 }} container>
                                                            <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>

                                                                <div style={{ fontWeight: 600 }}>

                                                                    <div
                                                                        style={{ display: 'inline-block', marginRight: 10, marginLeft: 10, verticalAlign: 'middle' }}
                                                                    >
                                                                        <span style={{ fontWeight: 500, fontSize: 12 }}>
                                                                            <HistoryToggle style={{ width: 18, height: 18, }} />
                                                                        </span>

                                                                    </div>

                                                                    <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}> {this.dictionary.monitorizare.timpMort} </span><br />

                                                                </div>
                                                            </Grid>

                                                            <Grid style={{ textAlign: 'left' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}>   {this.u.secondsToHoursAndMinutes(this.state.aplicatiiAll.idle)}</span>
                                                            </Grid>

                                                            <Divider style={{ marginTop: 10, backgroundColor: '#F2F2F2' }} className="pm-divider" />
                                                        </Grid>

                                                        <Grid style={{ paddingTop: 10, }} container>
                                                            <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>

                                                                <div style={{ fontWeight: 600 }}>

                                                                    <div
                                                                        style={{ display: 'inline-block', marginRight: 10, marginLeft: 10, verticalAlign: 'middle' }}
                                                                    >
                                                                        <span style={{ fontWeight: 500, fontSize: 12 }}>
                                                                            <SportSoccer style={{ width: 18, height: 18, }} />
                                                                        </span>

                                                                    </div>

                                                                    <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}> {this.dictionary.monitorizare.pauza} </span><br />

                                                                </div>
                                                            </Grid>

                                                            <Grid style={{ textAlign: 'left' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}>   {this.u.secondsToHoursAndMinutes(this.state.aplicatiiAll.pauza_total * 60)}</span>
                                                            </Grid>
                                                            <Divider style={{ marginTop: 10, backgroundColor: '#F2F2F2' }} className="pm-divider" />

                                                        </Grid>

                                                        <Grid style={{ paddingTop: 10, }} container>
                                                            <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>

                                                                <div style={{ fontWeight: 600 }}>

                                                                    <div
                                                                        style={{ display: 'inline-block', marginRight: 10, marginLeft: 10, verticalAlign: 'middle' }}
                                                                    >
                                                                        <span style={{ fontWeight: 500, fontSize: 12 }}> <i style={{
                                                                            verticalAlign: 'bottom',
                                                                            fontSize: 18,
                                                                        }} className='material-icons'>today</i>  </span>

                                                                    </div>

                                                                    <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}> {this.dictionary.monitorizare.totalLucrat} </span><br />

                                                                </div>
                                                            </Grid>

                                                            <Grid style={{ textAlign: 'left' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}>   {this.u.secondsToHoursAndMinutes(((this.state.aplicatiiAll.pauza_total * 60) + this.state.aplicatiiAll.idle + this.state.aplicatiiAll.timp_productiv + this.state.aplicatiiAll.timp_neproductiv))}</span>
                                                            </Grid>


                                                        </Grid>

                                                    </Grid>
                                                </Grid>

                                            </Grid>
                                            <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                {this.state.aplicatiiAll.aplicatii_folosite_principale.filter(app => app.is_productive === 1).length > 0 &&
                                                    <Grid container>
                                                        <Grid style={{ textAlign: 'left', padding: 10, }} item xs={12} sm={12} md={12} lg={12} xl={12} >

                                                            <h5 className='evaluare-noua-subtitlu pm-monitorizare-bold-text' style={{ marginTop: 0 }} >

                                                                <span>{this.dictionary.monitorizare.aplicatiiProductive}</span>
                                                            </h5>
                                                        </Grid>
                                                        <Grid className='pm-monitor-container-scroll' style={{ height: 214, overflow: 'scroll', paddingLeft: 10 }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                            {this.state.aplicatiiAll.aplicatii_folosite_principale.filter(app => app.is_productive === 1).map((app, idx) => {
                                                                return (
                                                                    <Grid style={{ paddingTop: 7 }} key={idx} container>
                                                                        <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>

                                                                            <div key={idx}>

                                                                                <div
                                                                                    style={{ display: 'inline-block', marginRight: 10, marginLeft: 10, verticalAlign: 'middle' }}
                                                                                >
                                                                                    <img

                                                                                        style={{ margin: 0, width: 24, height: 24 }}
                                                                                        src={app.icon ? `${this.ws.adresaMedia}/monitorizare/icons/${app.icon}` : generic}
                                                                                    />

                                                                                </div>

                                                                                <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}>    {app.app_name.length > 100 ? app.app_name.substring(0, 90) + '...' : app.app_name}</span><br />

                                                                            </div>
                                                                        </Grid>

                                                                        <Grid style={{ textAlign: 'left' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                            <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}>    {this.u.secondsToMinute(app.seconds_used)}</span>
                                                                        </Grid>

                                                                        {idx < this.state.aplicatiiAll.aplicatii_folosite_principale.filter(app => app.is_productive === 1).length - 1 &&
                                                                            <Divider style={{ marginTop: 5, backgroundColor: '#F2F2F2' }} className="pm-divider" />
                                                                        }
                                                                    </Grid>
                                                                )
                                                            })}

                                                        </Grid>
                                                    </Grid>
                                                }


                                            </Grid>
                                            <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                {this.state.aplicatiiAll.aplicatii_folosite_principale.filter(app => app.is_productive !== 1).length > 0 &&
                                                    <Grid container>
                                                        <Grid style={{ textAlign: 'left', padding: 10, }} item xs={12} sm={12} md={12} lg={12} xl={12} >

                                                            <h5 className='evaluare-noua-subtitlu pm-monitorizare-bold-text' style={{ marginTop: 0 }} >

                                                                <span>{this.dictionary.monitorizare.aplicatiiNeproductive}</span>
                                                            </h5>
                                                        </Grid>
                                                        <Grid className='pm-monitor-container-scroll' style={{ height: 214, overflow: 'scroll', paddingLeft: 10 }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                            {this.state.aplicatiiAll.aplicatii_folosite_principale.filter(app => app.is_productive !== 1).map((app, idx) => {
                                                                return (
                                                                    <Grid style={{ paddingTop: 7 }} key={idx} container>
                                                                        <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>

                                                                            <div key={idx}>

                                                                                <div
                                                                                    style={{ display: 'inline-block', marginRight: 10, marginLeft: 10, verticalAlign: 'middle' }}
                                                                                >
                                                                                    <img

                                                                                        style={{ margin: 0, width: 24, height: 24 }}
                                                                                        src={app.icon ? `${this.ws.adresaMedia}/monitorizare/icons/${app.icon}` : generic}
                                                                                    />

                                                                                </div>

                                                                                <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}>    {app.app_name.length > 100 ? app.app_name.substring(0, 90) + '...' : app.app_name}</span><br />

                                                                            </div>
                                                                        </Grid>

                                                                        <Grid style={{ textAlign: 'left' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                            <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}>    {this.u.secondsToMinute(app.seconds_used)}</span>
                                                                        </Grid>

                                                                        {idx < this.state.aplicatiiAll.aplicatii_folosite_principale.filter(app => app.is_productive !== 1).length - 1 &&
                                                                            <Divider style={{ marginTop: 5, backgroundColor: '#F2F2F2' }} className="pm-divider" />
                                                                        }
                                                                    </Grid>
                                                                )
                                                            })}

                                                        </Grid>
                                                    </Grid>
                                                }

                                            </Grid>
                                            <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                {this.state.aplicatiiAll.etichete.length > 0 &&


                                                    <Grid container>
                                                        <Grid style={{ textAlign: 'left', padding: 10, }} item xs={12} sm={12} md={12} lg={12} xl={12} >

                                                            <h5 className='evaluare-noua-subtitlu pm-monitorizare-bold-text' style={{ marginTop: 0 }} >

                                                                <span>{this.dictionary.monitorizare.eticheteFolosite}</span>
                                                            </h5>
                                                        </Grid>

                                                        <Grid className='pm-monitor-container-scroll' style={{ height: 214, overflow: 'scroll', paddingLeft: 10 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                            {this.state.aplicatiiAll.etichete.map((app, idx) => {
                                                                return (
                                                                    <Grid style={{ paddingTop: 6 }} key={idx} container>
                                                                        <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>

                                                                            <div style={{ paddingLeft: 10 }} key={idx}>



                                                                                <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}>    {app.eticheta}</span><br />

                                                                            </div>
                                                                        </Grid>

                                                                        <Grid style={{ textAlign: 'left' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                            <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}>    {this.u.secondsToMinute(app.seconds_used)}</span>
                                                                        </Grid>

                                                                        {idx < this.state.aplicatiiAll.etichete.length - 1 &&
                                                                            <Divider style={{ marginTop: 5, backgroundColor: '#F2F2F2' }} className="pm-divider" />
                                                                        }
                                                                    </Grid>
                                                                )
                                                            })}


                                                        </Grid>
                                                    </Grid>



                                                }
                                            </Grid>
                                        </Grid>
                                    </Grid>





                                </Grid>



                            </Grid>


                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <Grid container>

                                    {this.state.angajati.length > 0 && this.state.angajati.map((a, idx) => {

                                        return (

                                            <Grid style={{ marginBottom: 20 }} key={idx} item xs={3} sm={3} md={3} lg={3} xl={3} >
                                                <Grid container className='pm-monitor-container' style={{ border: '1px solid #bbbbbb', margin: 'auto' }}>
                                                    <Grid style={{ padding: 10, }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                        <Grid container>
                                                            <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                {
                                                                    a.poza &&
                                                                    <div
                                                                        className='pm-angajati-picture'

                                                                        style={{ backgroundImage: `url('${a.poza ? (new Ws().adresaMedia + '/Angajati/' + a.poza) : avatar}')`, width: 36, height: 36, padding: 5 }}>

                                                                    </div>
                                                                }
                                                                {!a.poza &&

                                                                    <Avatar
                                                                        className='pm-angajati-picture'
                                                                        style={{ display: 'inline-block', textAlign: 'center', height: 24, width: 24, backgroundColor: new Utils().culoriUtilizatori(a.id), padding: 5, cursor: 'pointer' }}>
                                                                        {/* <i style={{ verticalAlign: '-webkit-baseline-middle', cursor: 'pointer' }} className='material-icons'>person</i> */}
                                                                        <span style={{ display: 'block' }}>{this.numeAvatar(a.nume)} </span>
                                                                    </Avatar>
                                                                    // <Avatar onClick={this.props.userClick} style={{ display: 'inline-flex' }} className='pm-avatar'> {this.getLitereAvatar(u.nume + ' ')} </Avatar>
                                                                }
                                                            </Grid>

                                                            <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>
                                                                <span style={{ fontWeight: 500, fontSize: 14 }}>    {a.nume}</span><br />
                                                                <span style={{
                                                                    fontSize: 12,
                                                                    color: '#9a9a9a'
                                                                }}>{a.functie}</span>
                                                            </Grid>

                                                        </Grid>



                                                    </Grid>

                                                    <Divider style={{ marginTop: 10, backgroundColor: '#C8C8C8' }} className="pm-divider" />
                                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                        <Grid style={{ paddingTop: 10 }} container>
                                                            <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>

                                                                <div style={{ fontWeight: 600 }}>

                                                                    <div
                                                                        style={{ display: 'inline-block', marginRight: 10, marginLeft: 10, verticalAlign: 'middle' }}
                                                                    >
                                                                        <span style={{ fontWeight: 500, fontSize: 12 }}>
                                                                            <ThumbUp style={{ width: 18, height: 18 }} /> </span>

                                                                    </div>

                                                                    <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}> {this.dictionary.monitorizare.timpProductiv} </span><br />

                                                                </div>
                                                            </Grid>

                                                            <Grid style={{ textAlign: 'left' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}>    {this.u.secondsToHoursAndMinutes(a.timp_productiv)} </span>
                                                            </Grid>

                                                            <Divider style={{ marginTop: 5, backgroundColor: '#F2F2F2' }} className="pm-divider" />
                                                        </Grid>

                                                        <Grid style={{ paddingTop: 10 }} container>
                                                            <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>

                                                                <div style={{ fontWeight: 600 }}>

                                                                    <div
                                                                        style={{ display: 'inline-block', marginRight: 10, marginLeft: 10, verticalAlign: 'middle' }}
                                                                    >
                                                                        <span style={{ fontWeight: 500, fontSize: 12 }}>
                                                                            <ThumbDown style={{ width: 18, height: 18 }} />  </span>

                                                                    </div>

                                                                    <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}> {this.dictionary.monitorizare.timpNeproductiv} </span><br />

                                                                </div>
                                                            </Grid>

                                                            <Grid style={{ textAlign: 'left' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}>   {this.u.secondsToHoursAndMinutes(a.timp_neproductiv)}</span>
                                                            </Grid>

                                                            <Divider style={{ marginTop: 5, backgroundColor: '#F2F2F2' }} className="pm-divider" />
                                                        </Grid>

                                                        <Grid style={{ paddingTop: 10 }} container>
                                                            <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>

                                                                <div style={{ fontWeight: 600 }}>

                                                                    <div
                                                                        style={{ display: 'inline-block', marginRight: 10, marginLeft: 10, verticalAlign: 'middle' }}
                                                                    >
                                                                        <span style={{ fontWeight: 500, fontSize: 12 }}>
                                                                            <HistoryToggle style={{ width: 18, height: 18 }} />  </span>

                                                                    </div>

                                                                    <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}> {this.dictionary.monitorizare.timpMort} </span><br />

                                                                </div>
                                                            </Grid>

                                                            <Grid style={{ textAlign: 'left' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}>   {this.u.secondsToHoursAndMinutes(a.idle)}</span>
                                                            </Grid>

                                                            <Divider style={{ marginTop: 5, backgroundColor: '#F2F2F2' }} className="pm-divider" />
                                                        </Grid>

                                                        <Grid style={{ paddingTop: 10 }} container>
                                                            <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>

                                                                <div style={{ fontWeight: 600 }}>

                                                                    <div
                                                                        style={{ display: 'inline-block', marginRight: 10, marginLeft: 10, verticalAlign: 'middle' }}
                                                                    >
                                                                        <span style={{ fontWeight: 500, fontSize: 12 }}>
                                                                            <SportSoccer style={{ width: 18, height: 18 }} /> </span>

                                                                    </div>

                                                                    <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}> {this.dictionary.monitorizare.pauza} </span><br />

                                                                </div>
                                                            </Grid>

                                                            <Grid style={{ textAlign: 'left' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}>   {this.u.secondsToHoursAndMinutes(a.pauza_total.time * 60)}</span>
                                                            </Grid>
                                                            <Divider style={{ marginTop: 5, backgroundColor: '#F2F2F2' }} className="pm-divider" />

                                                        </Grid>

                                                        <Grid style={{ paddingTop: 10 }} container>
                                                            <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>

                                                                <div style={{ fontWeight: 600 }}>

                                                                    <div
                                                                        style={{ display: 'inline-block', marginRight: 10, marginLeft: 10, verticalAlign: 'middle' }}
                                                                    >
                                                                        <span style={{ fontWeight: 500, fontSize: 12 }}> <i style={{
                                                                            verticalAlign: 'bottom',
                                                                            fontSize: 18,
                                                                        }} className='material-icons'>today</i>  </span>

                                                                    </div>

                                                                    <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}> {this.dictionary.monitorizare.totalLucrat} </span><br />

                                                                </div>
                                                            </Grid>

                                                            <Grid style={{ textAlign: 'left' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}>   {this.u.secondsToHoursAndMinutes(((a.pauza_total.time * 60) + a.idle + a.timp_productiv + a.timp_neproductiv))}</span>
                                                            </Grid>


                                                        </Grid>

                                                    </Grid>

                                                    {a.aplicatii_folosite_principale.filter(app => app.is_productive === 1).length > 0 &&
                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                            <Grid container>
                                                                <Divider style={{ marginTop: 10, backgroundColor: '#C8C8C8' }} className="pm-divider" />
                                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                    <h5 className='evaluare-noua-subtitlu pm-monitorizare-bold-text' style={{ textAlign: 'left', paddingLeft: 20, paddingTop: 10, marginTop: 0 }} > {this.dictionary.monitorizare.aplicatiiProductive}</h5>

                                                                </Grid>

                                                                <Grid className='pm-monitor-container-scroll' style={{ height: 117, overflow: 'scroll' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                    {a.aplicatii_folosite_principale.filter(app => app.is_productive === 1).map((app, idx) => {
                                                                        return (
                                                                            <Grid style={{ paddingTop: 5 }} key={idx} container>
                                                                                <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>

                                                                                    <div key={idx}>

                                                                                        <div
                                                                                            style={{ display: 'inline-block', marginRight: 10, marginLeft: 10, verticalAlign: 'middle' }}
                                                                                        >
                                                                                            <img

                                                                                                style={{ margin: 0, width: 24, height: 24 }}
                                                                                                src={app.icon ? `${this.ws.adresaMedia}/monitorizare/icons/${app.icon}` : generic}
                                                                                            />

                                                                                        </div>

                                                                                        <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}>    {app.app_name.length > 100 ? app.app_name.substring(0, 90) + '...' : app.app_name}</span><br />

                                                                                    </div>
                                                                                </Grid>

                                                                                <Grid style={{ textAlign: 'left' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                                    <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}>    {this.u.secondsToMinute(app.seconds_used)}</span>
                                                                                </Grid>
                                                                                {idx < a.aplicatii_folosite_principale.filter(app => app.is_productive === 1).length - 1 &&
                                                                                    <Divider style={{ marginTop: 5, backgroundColor: '#F2F2F2' }} className="pm-divider" />
                                                                                }
                                                                            </Grid>
                                                                        )
                                                                    })}


                                                                </Grid>
                                                            </Grid>

                                                        </Grid>
                                                    }


                                                    {a.aplicatii_folosite_principale.filter(app => app.is_productive !== 1).length > 0 &&

                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                            <Grid container>
                                                                <Divider style={{ marginTop: 10, backgroundColor: '#C8C8C8' }} className="pm-divider" />
                                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                    <h5 className='evaluare-noua-subtitlu pm-monitorizare-bold-text' style={{ textAlign: 'left', paddingLeft: 20, paddingTop: 10, marginTop: 0 }} > {this.dictionary.monitorizare.aplicatiiNeproductive}</h5>

                                                                </Grid>

                                                                <Grid className='pm-monitor-container-scroll' style={{ height: 117, overflow: 'scroll' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                    {a.aplicatii_folosite_principale.filter(app => app.is_productive !== 1).map((app, idx) => {
                                                                        return (
                                                                            <Grid style={{ paddingTop: 5 }} key={idx} container>
                                                                                <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>

                                                                                    <div key={idx}>

                                                                                        <div
                                                                                            style={{ display: 'inline-block', marginRight: 10, marginLeft: 10, verticalAlign: 'middle' }}
                                                                                        >
                                                                                            <img

                                                                                                style={{ margin: 0, width: 24, height: 24 }}
                                                                                                src={app.icon ? `${this.ws.adresaMedia}/monitorizare/icons/${app.icon}` : generic}
                                                                                            />

                                                                                        </div>

                                                                                        <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}>    {app.app_name.length > 100 ? app.app_name.substring(0, 90) + '...' : app.app_name}</span><br />

                                                                                    </div>
                                                                                </Grid>

                                                                                <Grid style={{ textAlign: 'left' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                                    <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}>    {this.u.secondsToMinute(app.seconds_used)}</span>
                                                                                </Grid>

                                                                                {idx < a.aplicatii_folosite_principale.filter(app => app.is_productive !== 1).length - 1 &&
                                                                                    <Divider style={{ marginTop: 5, backgroundColor: '#F2F2F2' }} className="pm-divider" />
                                                                                }
                                                                            </Grid>
                                                                        )
                                                                    })}


                                                                </Grid>
                                                            </Grid>

                                                        </Grid>

                                                    }

                                                    {a.etichete.length > 0 &&

                                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                            <Grid container>
                                                                <Divider style={{ marginTop: 10, backgroundColor: '#C8C8C8' }} className="pm-divider" />
                                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                    <h5 className='evaluare-noua-subtitlu pm-monitorizare-bold-text' style={{ textAlign: 'left', paddingLeft: 20, paddingTop: 10, marginTop: 0 }} > {this.dictionary.monitorizare.eticheteFolosite}</h5>

                                                                </Grid>

                                                                <Grid className='pm-monitor-container-scroll' style={{ height: 117, overflow: 'scroll' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                                    {a.etichete.map((app, idx) => {
                                                                        return (
                                                                            <Grid style={{ paddingTop: 5 }} key={idx} container>
                                                                                <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>

                                                                                    <div style={{ paddingLeft: 10 }} key={idx}>



                                                                                        <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}>    {app.eticheta}</span><br />

                                                                                    </div>
                                                                                </Grid>

                                                                                <Grid style={{ textAlign: 'left' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                                    <span className="pm-monitorizare-normal-text" style={{ fontWeight: 500 }}>    {this.u.secondsToMinute(app.seconds_used)}</span>
                                                                                </Grid>

                                                                                {idx < a.etichete.length - 1 &&
                                                                                    <Divider style={{ marginTop: 5, backgroundColor: '#F2F2F2' }} className="pm-divider" />
                                                                                }
                                                                            </Grid>
                                                                        )
                                                                    })}


                                                                </Grid>
                                                            </Grid>

                                                        </Grid>

                                                    }


                                                </Grid>
                                            </Grid>






                                        )
                                    })}

                                </Grid>


                            </Grid>



                        </Grid>

                    </Grid>
                </Grid>

            </div >
        );
    }
}